var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWritten(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.211,
    height: 17.34,
    viewBox: "0 0 13.211 17.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_000000ff",
    "data-name": "#000000ff",
    transform: "translate(-60.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M61.388,0H71.677a.519.519,0,0,1,.453.505c0,.52,0,1.04,0,1.561.508,0,1.016,0,1.524,0a.514.514,0,0,1,.508.539V16.8a.531.531,0,0,1-.433.543h-10.3a.524.524,0,0,1-.438-.505c0-.509,0-1.018,0-1.527-.486,0-.971,0-1.457,0a.6.6,0,0,1-.307-.063.517.517,0,0,1-.269-.478q0-7,0-13.99a.987.987,0,0,1,.075-.534A.559.559,0,0,1,61.388,0m.584,1.016V14.292h9.144V1.016H61.972m10.16,2.066q0,5.843,0,11.685a.518.518,0,0,1-.289.489.92.92,0,0,1-.42.052H64v1.016h9.144V3.082Z",
    transform: "translate(0)",
    fill: "#15803d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M121.4,90.982a2.345,2.345,0,0,1,.331-.01h2.781a.517.517,0,0,1,.49.292.506.506,0,0,1-.082.556.526.526,0,0,1-.41.168c-1,0-2.01,0-3.014,0a.507.507,0,0,1-.095-1.005Z",
    transform: "translate(-57.999 -87.89)",
    fill: "#15803d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M121.406,150.981a2.018,2.018,0,0,1,.3-.01q2.946,0,5.893,0a.507.507,0,0,1,.217.964.932.932,0,0,1-.422.051h-5.656a.966.966,0,0,1-.473-.061.507.507,0,0,1,.141-.946Z",
    transform: "translate(-58.006 -145.857)",
    fill: "#15803d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M121.385,210.978a1.961,1.961,0,0,1,.3-.01q2.946,0,5.893,0a.507.507,0,0,1,.217.964.927.927,0,0,1-.42.051h-5.862a.518.518,0,0,1-.5-.313A.51.51,0,0,1,121.385,210.978Z",
    transform: "translate(-57.984 -203.823)",
    fill: "#15803d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M121.383,270.981a1.987,1.987,0,0,1,.3-.01q2.947,0,5.9,0a.507.507,0,0,1,.217.964.933.933,0,0,1-.422.051h-5.858a.518.518,0,0,1-.5-.314A.51.51,0,0,1,121.383,270.981Z",
    transform: "translate(-57.983 -261.793)",
    fill: "#15803d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M241.41,330.991a.991.991,0,0,1,.165-.011c.654,0,1.307,0,1.961,0a.507.507,0,1,1,0,1.015c-.665,0-1.33,0-1.994,0a.521.521,0,0,1-.466-.242A.51.51,0,0,1,241.41,330.991Z",
    transform: "translate(-173.945 -319.771)",
    fill: "#15803d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritten);
export default __webpack_public_path__ + "static/media/Written.be86fadc95c50b14af25ef8842bdf15c.svg";
export { ForwardRef as ReactComponent };